import { collection, getDocs, limit, orderBy, query } from 'firebase/firestore';
import { db, handleFirestoreError, OperationType } from './firebase';
import { casesListCacheKey, setCached } from './listCache';

export interface CaseListRecord {
  workspaceId?: string;
  lawyerId?: string;
  assignedTo?: string[];
  visibility?: string;
  id: string;
  title: string;
  caseMatter?: string;
  matterType?: string;
  courtType: string;
  district?: string;
  court: string;
  caseNumber: string;
  status: string;
  stage: string;
  caseCategory?: string;
  caseType?: string;
  lastProceeding?: string;
  nextHearingDate?: string;
  plaintiffs?: unknown[];
  defendants?: unknown[];
  description?: string;
  updatedAt?: string;
  createdAt?: string;
  parentCaseId?: string;
  rootCaseId?: string;
  linkType?: string;
  matterStatus?: string;
  category?: string;
  fixedFor?: string;
  courtRoom?: string;
  courtRoomMissing?: boolean;
  organizationId?: string;
  organizationName?: string;
}

export interface CasesListCacheData {
  cases: CaseListRecord[];
}

export async function fetchCasesList(
  workspaceId: string,
  closedOnly = false,
): Promise<CasesListCacheData> {
  const ws = workspaceId || 'no-ws';
  const casesRef = collection(db, 'workspaces', ws, 'cases');
  const q = query(casesRef, orderBy('createdAt', 'desc'), limit(100));

  const snapshot = await getDocs(q);
  const casesData: CaseListRecord[] = [];
  snapshot.forEach((docSnap) => {
    casesData.push({ id: docSnap.id, ...docSnap.data() } as CaseListRecord);
  });

  const result = { cases: casesData };
  setCached(casesListCacheKey(workspaceId, closedOnly), result);
  return result;
}

export async function fetchCasesListSafe(
  workspaceId: string,
  closedOnly = false,
): Promise<CasesListCacheData | null> {
  try {
    return await fetchCasesList(workspaceId, closedOnly);
  } catch (error) {
    handleFirestoreError(error, OperationType.GET, 'cases');
    return null;
  }
}
